import * as React from "react";
import { useTranslation } from "react-i18next";
import { StatusPage } from "../components/ui/StatusPage";

export function MaintenancePage() {
  const { t } = useTranslation("errors");
  return (
    <StatusPage
      variant="maintenance"
      eyebrow={t("maintenanceEyebrow", "THE VEIL IS DRAWN")}
      title={t("maintenanceTitle", "We're realigning the stars")}
      body={t("maintenanceBody", "The site is briefly closed for tending. Return shortly and all will be clear.")}
    />
  );
}
